module.exports = __webpack_public_path__ + "mainassets/img/tile2h.c6055c89.jpg";